import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Dimensions, Platform, StyleSheet, View } from "react-native";
import { initialWindowMetrics, SafeAreaInsetsContext, SafeAreaProvider } from "react-native-safe-area-context";
var _Dimensions_get = Dimensions.get("window"), _Dimensions_get_width = _Dimensions_get.width, width = _Dimensions_get_width === void 0 ? 0 : _Dimensions_get_width, _Dimensions_get_height = _Dimensions_get.height, height = _Dimensions_get_height === void 0 ? 0 : _Dimensions_get_height;
// To support SSR on web, we need to have empty insets for initial values
// Otherwise there can be mismatch between SSR and client output
// We also need to specify empty values to support tests environments
var initialMetrics = Platform.OS === "web" || initialWindowMetrics == null ? {
    frame: {
        x: 0,
        y: 0,
        width: width,
        height: height
    },
    insets: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }
} : initialWindowMetrics;
export default function SafeAreaProviderCompat(param) {
    var children = param.children, style = param.style;
    return /*#__PURE__*/ _jsx(SafeAreaInsetsContext.Consumer, {
        children: function(insets) {
            if (insets) {
                // If we already have insets, don't wrap the stack in another safe area provider
                // This avoids an issue with updates at the cost of potentially incorrect values
                // https://github.com/react-navigation/react-navigation/issues/174
                return /*#__PURE__*/ _jsx(View, {
                    style: [
                        styles.container,
                        style
                    ],
                    children: children
                });
            }
            return /*#__PURE__*/ _jsx(SafeAreaProvider, {
                initialMetrics: initialMetrics,
                style: style,
                children: children
            });
        }
    });
}
SafeAreaProviderCompat.initialMetrics = initialMetrics;
var styles = StyleSheet.create({
    container: {
        flex: 1
    }
});
